module.exports = __webpack_public_path__ + "img/serverBack.49de749b.jpg";